import { ajax } from "@/plugins/ajax";
export default {
  namespaced: true,
  state: {
    details: [],
    loading: false,
  },
  getters: {
    details: (state) => state.details,
    loading: (state) => state.loading,
  },
  actions: {
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/CustomerLegalsQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/CustomerLegals", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createAgent({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentLegals", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createBranch({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentLegals/who-is-type-of-branch", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    editBranch({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("BusinessParties/api/AgentLegals/who-is-type-of-branch", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createPromoter({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/PromoterLegals", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("BusinessParties/api/CustomerLegals", model).then(() => {
        //dispatch('fetch')
      });
    },
    updateAgent({ commit, dispatch }, model) {
      return ajax.put("BusinessParties/api/AgentLegals", model).then(() => {
        //dispatch('fetch')
      });
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
  },
};
